import { Container, Row, Col } from "react-bootstrap";
import JobCandidateFilter from "../../../../components/filteration/JobCandiditeFilter";
import Avaliablecandidate from "../../../../components/Avaliablecandidate";
import { useEffect, useState, useContext } from "react";
import { ShopContext } from "../../../../config/shopContext";
import { useGetEmployeesQuery, useLazyGetFilteredEmployeesQuery } from "../../../../features/user/userApiSlice";
import BackArrow from "../../../../components/backArrow";

const AvailableCandidatesFilter = () => {
  const contextType = "jobCandidates";

  /* ---------------- SHOP CONTEXT ---------------- */
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(contextType);

  /* ---------------- STATES ---------------- */
  const [isloading, setIsloading] = useState(false);
  const [employeedata, setEmployeedata] = useState(
    currentData?.shopdata || []
  );

  /* ---------------- FILTER STATE (FROM CONTEXT) ---------------- */
  const [candidatedata, setCandidatedata] = useState(
    currentData?.additionalData || {
      jobtitle: "",
      categoryid: "",
      subCategoryid: "",
      siteremote: "",
      jobtype: "",
      country: "",
      state: "",
      city: "",
    }
  );

  /* ---------------- CATEGORY & TITLE ---------------- */
  const [jobdataone, SetJobdataone] = useState({
    categoryid: "",
    title: "",
  });

  // Split only on the first "." so category names that contain dots stay intact.
  const parseIdName = (value = "") => {
    const idx = String(value).indexOf(".");
    if (idx === -1) return [value];
    return [value.slice(0, idx), value.slice(idx + 1)];
  };

  const Handledata = (e) => {
    const { name, value } = e.target;
    const parsed = parseIdName(value);

    SetJobdataone((prev) => {
      // Title change invalidates category + subcategory; category change
      // invalidates subcategory so options stay in sync with the parent.
      if (name === "title") {
        return { title: parsed, categoryid: "" };
      }
      if (name === "categoryid") {
        return { ...prev, categoryid: parsed };
      }
      return { ...prev, [name]: parsed };
    });

    if (name === "title") {
      setCandidatedata((prev) => ({
        ...prev,
        categoryid: "",
        subCategoryid: "",
      }));
    } else if (name === "categoryid") {
      setCandidatedata((prev) => ({
        ...prev,
        subCategoryid: "",
      }));
    }
  };

  const categoryidone = jobdataone?.categoryid?.[0] || "";
  const categoryName = jobdataone?.categoryid?.[1] || "";
  const titleName = jobdataone?.title?.[1] || "";

  /* ---------------- SYNC CATEGORY & TITLE ---------------- */
  useEffect(() => {
    setCandidatedata((prev) => ({
      ...prev,
      categoryid: categoryidone || "",
      jobtitle: titleName || "",
    }));
  }, [categoryidone, titleName]);

  /* ---------------- INPUT HANDLER ---------------- */
  const Handlecandidate = (e) => {
    const { name, value } = e.target;
    setCandidatedata((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const hasPersistedData = (currentData?.shopdata?.length || 0) > 0;
  const { data: initRes, isLoading: initLoading } = useGetEmployeesQuery(undefined, { skip: hasPersistedData });
  const [getFilteredEmployees, { isLoading: isFilterLoading }] = useLazyGetFilteredEmployeesQuery();

  /* ---------------- FILTER API CALL ---------------- */
  const FilterCandidate = () => {
    setEmployeedata([]);

    // build query dynamically (NO undefined)
    const params = {};
    Object.entries(candidatedata).forEach(([key, value]) => {
      if (value && value.trim() !== "") {
        params[key] = value.trim();
      }
    });

    const query = new URLSearchParams(params).toString();

    getFilteredEmployees(query)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          const employeesList = res?.employees || res?.data?.Employees || res?.data?.employees || [];
          setEmployeedata(employeesList);

          // SAVE IN CONTEXT
          updateFilteredData(
            contextType,
            employeesList,
            [],
            candidatedata
          );
        }
      })
      .catch(() => {});
  };

  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    if (hasPersistedData) return;
    if (initRes?.data?.Employees) {
      const employees = initRes.data.Employees || [];
      setEmployeedata(employees);
      updateFilteredData(contextType, employees, [], candidatedata);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initRes]);

  /* ---------------- UI ---------------- */
  return (
    <Container className="available-candidates-page">
      <BackArrow back="/BuyingSide" mystyle="d-lg-none available-candidates-mobile-back" />
      <Row className="available-candidates-row">
        <Col lg="4" className="screenHeight">
          <div className="border b-radius height_100">
            <JobCandidateFilter
              title="Search Candidate by Category, Area, Job Type"
              category="Job Title"
              search="Search by Job Type"
              Handlecandidate={Handlecandidate}
              FilterCandidate={FilterCandidate}
              Handledata={Handledata}
              categoryName={categoryName}
              titleName={titleName}
              additionalCandidateData={candidatedata}
            />
          </div>
        </Col>

        <Col lg="8" className="screenHeight">
          <div className="border b-radius">
            <Avaliablecandidate
              employeedata={employeedata}
              isloading={initLoading || isFilterLoading}
              mobileBackArrow
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AvailableCandidatesFilter;
